if (typeof debounce === 'undefined') {
  var debounce = function(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');
      this._scrollTicking = false;
      this._stickyOffset = 0;

      document.addEventListener('keyup', (e) => {
        if (e.code?.toUpperCase() === 'ESCAPE') {
          if (this.toggle) {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
            document.body.classList.remove('mobile-menu-open');
            document.documentElement.classList.remove('mobile-menu-open');
          }
          this.closeDesktopDrawer();
        }
      });
      if (this.toggle && this.toggle.querySelector('.mobile-toggle')) {
        this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
          if (this.toggle.classList.contains('active')) {
            e.preventDefault();
            document.body.classList.remove('mobile-menu-open');
            document.documentElement.classList.remove('mobile-menu-open');
            this.toggle.classList.remove('active');
            this.closeAnimation(this.toggle);
          } else {
            document.body.classList.add('mobile-menu-open');
            document.documentElement.classList.add('mobile-menu-open');
            setTimeout(() => {
              this.toggle.classList.add('active');
            });
          }
          window.dispatchEvent(new Event('resize.resize-select'));
        });
      }

      // Desktop Drawer Toggles
      this.desktopToggle = this.querySelector('.desktop-drawer-toggle');
      this.desktopDrawerOverlay = this.querySelector('.desktop-drawer-overlay');
      
      if (this.desktopToggle) {
        this.desktopToggle.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleDesktopDrawer();
        });
      }
      
      if (this.desktopDrawerOverlay) {
        this.desktopDrawerOverlay.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeDesktopDrawer();
        });
      }

      // Hover Tabs Event Listener Initialization
      this.tabItems = this.querySelectorAll('.desktop-drawer-tab-item');
      this.tabPanels = this.querySelectorAll('.desktop-drawer-tab-panel');

      if (this.tabItems.length > 0) {
        this.tabItems.forEach((item) => {
          item.addEventListener('mouseenter', () => {
            const tabId = item.getAttribute('data-tab-id');
            this.activateTab(tabId);
          });
        });
      }

      // Nested Hover Subtabs Event Listener Initialization
      const subtabTriggers = this.querySelectorAll('.desktop-subtab-trigger-wrap');
      if (subtabTriggers.length > 0) {
        subtabTriggers.forEach((trigger) => {
          trigger.addEventListener('mouseenter', () => {
            const subtabId = trigger.getAttribute('data-subtab-id');
            const panel = trigger.closest('.desktop-drawer-tab-panel');
            if (panel) {
              const subtabPanels = panel.querySelectorAll('.desktop-drawer-subtab-panel');
              const targetPanel = panel.querySelector(`#${subtabId}`);
              
              if (targetPanel) {
                // Deactivate all subtab panels within this tab panel
                subtabPanels.forEach(p => p.classList.remove('is-active'));
                // Activate target panel
                targetPanel.classList.add('is-active');
              } else {
                // If hovered item has no sub-panel (e.g. Catalog/Home), show default promo
                const defaultPanel = panel.querySelector('.desktop-drawer-promo-col-wrapper.desktop-subtab-default-panel');
                if (defaultPanel) {
                  subtabPanels.forEach(p => p.classList.remove('is-active'));
                  defaultPanel.classList.add('is-active');
                }
              }
            }
          });
        });
      }


      const drawerColumns = this.querySelector('.desktop-drawer-columns');
      if (drawerColumns) {
        drawerColumns.addEventListener('mouseleave', () => {
          this.resetToDefaultTab();
        });
      }

      // Cache sticky offset and recalculate on resize
      this._cacheStickyOffset();
      window.addEventListener('resize', debounce(() => {
        this._cacheStickyOffset();
      }, 100));

      // Single scroll listener with rAF throttle
      window.addEventListener('scroll', () => {
        if (!this._scrollTicking) {
          this._scrollTicking = true;
          requestAnimationFrame(() => {
            this.setStickyClass();
            this.setHeaderOffset();
            this.setHeaderHeight();
            this._scrollTicking = false;
          });
        }
      }, { passive: true });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {
        window.addEventListener('scroll', () => this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    _cacheStickyOffset() {
      if (this.classList.contains('header-sticky--active')) {
        // Skip recalculation while sticky — the header is position:sticky at top:0,
        // so getBoundingClientRect().top would return 0 and corrupt the offset.
        if (this.classList.contains('is-sticky')) {
          return;
        }
        this._stickyOffset = parseInt(this.header_section.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
      }
    }

// comment_by pradeep
   // setStickyClass() {
      //if (this.classList.contains('header-sticky--active')) {
        //this.classList.toggle('is-sticky', window.scrollY >= this._stickyOffset && window.scrollY > 0);
     // }
    //}



setStickyClass() {
  const currentScrollY = window.scrollY;

  // 1. sticky state check (VERY IMPORTANT)
  const isSticky =
    this.classList.contains('header-sticky--active') &&
    currentScrollY >= this._stickyOffset &&
    currentScrollY > 0;

  this.classList.toggle('is-sticky', isSticky);

  if (!isSticky) {
    this.classList.remove('sticky-up', 'sticky-down');
    this._lastScrollY = currentScrollY;
    return;
  }

  // 2. direction check
  if (currentScrollY > this._lastScrollY + 5) {
    this.classList.add('sticky-down');
    this.classList.remove('sticky-up');
    console.log('DOWN');
  } 
  else if (currentScrollY < this._lastScrollY - 5) {
    this.classList.add('sticky-up');
    this.classList.remove('sticky-down');
    console.log('UP');
  }

  this._lastScrollY = currentScrollY;
}

    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentLinksEnabled = this.menu.dataset.parentLinks === 'true';

      // When parent links setting is on, only arrow opens submenu
      if (parentLinksEnabled) {
        event.preventDefault();
        const isArrowClick = event.target.closest('.link-forward');

        if (!isArrowClick) {
          const anchor = summaryElement.querySelector('a');
          if (anchor && anchor.href) {
            window.location.href = anchor.href;
          }
          return;
        }
        // Arrow clicked — manually open details
        detailsElement.setAttribute('open', '');
      }

      const parentMenuElement = detailsElement.closest('.link-container');

      // Stamp deferred template content on first open
      const tpl = detailsElement.querySelector(':scope > template.mobile-menu-deferred');
      if (tpl) {
        tpl.replaceWith(tpl.content.cloneNode(true));
        // Re-bind back buttons for the newly stamped content
        detailsElement.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
        detailsElement.querySelectorAll('details.link-container summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      }

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    toggleDesktopDrawer() {
      const isOpen = document.body.classList.contains('desktop-drawer-open');
      if (isOpen) {
        this.closeDesktopDrawer();
      } else {
        this.openDesktopDrawer();
      }
    }
    openDesktopDrawer() {
      document.body.classList.add('desktop-drawer-open', 'desktop-drawer-open-lock');
      document.documentElement.classList.add('desktop-drawer-open-lock');
      const desktopDrawerToggle = this.querySelector('.desktop-drawer-toggle');
      if (desktopDrawerToggle) {
        desktopDrawerToggle.setAttribute('aria-expanded', 'true');
      }
      
      // Reset to default tab (global collection list) on open
      const defaultTab = this.querySelector('#tab-default');
      if (defaultTab) {
        // Deactivate all hover tabs and panels
        if (this.tabItems) this.tabItems.forEach(item => item.classList.remove('is-active'));
        if (this.tabPanels) this.tabPanels.forEach(panel => panel.classList.remove('is-active'));
        // Activate default panel
        defaultTab.classList.add('is-active');
      } else {
        // Fallback to first tab if default panel doesn't exist
        if (this.tabItems && this.tabItems.length > 0) {
          const firstTabId = this.tabItems[0].getAttribute('data-tab-id');
          this.activateTab(firstTabId);
        }
      }
    }
    closeDesktopDrawer() {
      document.body.classList.remove('desktop-drawer-open', 'desktop-drawer-open-lock');
      document.documentElement.classList.remove('desktop-drawer-open-lock');
      const desktopDrawerToggle = this.querySelector('.desktop-drawer-toggle');
      if (desktopDrawerToggle) {
        desktopDrawerToggle.setAttribute('aria-expanded', 'false');
      }
    }
    activateTab(tabId) {
      if (!tabId) return;
      
      // Hide default tab panel when any other tab is activated
      const defaultTab = this.querySelector('#tab-default');
      if (defaultTab) {
        defaultTab.classList.remove('is-active');
      }
      
      this.tabItems.forEach((item) => {
        if (item.getAttribute('data-tab-id') === tabId) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
      
      this.tabPanels.forEach((panel) => {
        if (panel.id === tabId) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    }
    resetToDefaultTab() {
      const defaultTab = this.querySelector('#tab-default');
      if (defaultTab) {
        // Deactivate all hover tabs and panels
        if (this.tabItems) this.tabItems.forEach(item => item.classList.remove('is-active'));
        if (this.tabPanels) this.tabPanels.forEach(panel => panel.classList.remove('is-active'));
        // Activate default panel
        defaultTab.classList.add('is-active');
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      // resize on initial load
      window.addEventListener('resize', debounce(() => {
        this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(() => {
        this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
